export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: number;
  updateTime: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '都市', slug: 'urban' },
  { name: '悬疑', slug: 'mystery' },
  { name: '动作', slug: 'action' },
  { name: '搞笑', slug: 'comedy' },
  { name: '古风', slug: 'historical' },
  { name: '耽美', slug: 'bl' },
  { name: '百合', slug: 'gl' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '重生之女王归来',
    author: '金敏雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20powerful%20queen%20in%20modern%20royal%20attire%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20palace%20interior%20background%2C%20webtoon%20cover%20style%2C%20high%20contrast%2C%20mysterious%20atmosphere%2C%20digital%20art%2C%20clean%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '前世惨死的女王重生成现代财阀千金，她发誓要夺回属于自己的一切。在复仇的路上，她意外邂逅了冷酷腹黑的总裁，两人从互相利用到真心相爱，一场跨越前世今生的爱恨纠葛就此展开。',
    status: '连载中',
    rating: 9.5,
    views: 1280000,
    chapters: 86,
    updateTime: '2026-08-04',
    tags: ['重生', '复仇', '恋爱', '总裁'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '我在异世界当剑圣',
    author: '李明浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20swordsman%20in%20medieval%20fantasy%20armor%20holding%20a%20glowing%20sword%2C%20magical%20energy%20surrounding%20him%2C%20epic%20fantasy%20landscape%20with%20dragons%20in%20background%2C%20webtoon%20cover%20style%2C%20cool%20blue%20and%20silver%20tones%2C%20dramatic%20composition%2C%20digital%20art&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '普通大学生意外穿越到剑与魔法的世界，凭借现代人的智慧和超强的剑术天赋，一步步成为传说中最强的剑圣。在这个充满魔法、龙族和暗黑势力的异世界中，他将书写属于自己的传奇！',
    status: '连载中',
    rating: 9.7,
    views: 2560000,
    chapters: 124,
    updateTime: '2026-08-05',
    tags: ['穿越', '剑术', '魔法', '冒险'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '暗恋的社长大人',
    author: '崔秀妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20stylish%20CEO%20man%20in%20modern%20office%20suit%20standing%20with%20a%20shy%20female%20employee%2C%20romantic%20tension%2C%20warm%20pink%20and%20beige%20tones%2C%20office%20background%20with%20city%20skyline%20through%20window%2C%20webtoon%20cover%20style%2C%20soft%20lighting%2C%20romantic%20digital%20art&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    description: '社恐小透明女主暗恋霸道上司三年，某天醉酒后不小心把社长的西装弄脏了，从此两人的命运开始纠缠在一起。原来社长早就注意到了这个害羞的女孩，一段甜蜜又搞笑的办公室恋情悄然展开。',
    status: '已完结',
    rating: 9.3,
    views: 1890000,
    chapters: 72,
    updateTime: '2026-07-20',
    tags: ['恋爱', '职场', '甜宠', '搞笑'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '悬疑之夜：消失的她',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20thriller%20illustration%20of%20a%20silhouetted%20woman%20disappearing%20into%20darkness%2C%20mysterious%20atmosphere%2C%20dark%20alley%20with%20rain%2C%20film%20noir%20vibe%2C%20red%20and%20black%20tones%2C%20webtoon%20cover%20style%2C%20suspenseful%20mood%2C%20digital%20art%2C%20high%20contrast&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '一名女大学生在深夜归家途中神秘失踪，负责调查此案的刑警发现这起失踪案与十年前的一桩连环杀人案有着惊人的相似之处。随着调查的深入，一个令人毛骨悚然的真相逐渐浮出水面。',
    status: '连载中',
    rating: 9.6,
    views: 1420000,
    chapters: 58,
    updateTime: '2026-08-03',
    tags: ['悬疑', '推理', '犯罪', '惊悚'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '武道巅峰',
    author: '韩志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20martial%20arts%20illustration%20of%20a%20powerful%20fighter%20in%20dynamic%20fighting%20pose%2C%20energy%20aura%20around%20body%2C%20anime%20action%20style%2C%20warm%20orange%20and%20dark%20tone%2C%20urban%20dojo%20background%2C%20webtoon%20cover%20style%2C%20intense%20expression%2C%20digital%20art&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '被欺凌的高中生韩志勋偶然救了一位隐居的武道大师，从此踏入武道世界。从一个被人看不起的弱者，到站在世界武道大赛的巅峰，他用拳头书写了一段热血沸腾的逆袭传奇！',
    status: '连载中',
    rating: 9.4,
    views: 2150000,
    chapters: 96,
    updateTime: '2026-08-05',
    tags: ['热血', '格斗', '逆袭', '校园'],
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: '班长大人是戏精',
    author: '尹恩惠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20chibi%20comedy%20illustration%20of%20a%20funny%20class%20president%20making%20exaggerated%20expressions%2C%20colorful%20school%20setting%2C%20bright%20and%20cheerful%20colors%2C%20webtoon%20cover%20style%2C%20humorous%20mood%2C%20cute%20digital%20art%2C%20pastel%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '转学生发现全校公认的完美班长居然是个中二病晚期患者！为了守住这个秘密，两人开始了爆笑又温馨的日常。当完美人设遇上中二灵魂，每一天都是社死现场！',
    status: '已完结',
    rating: 9.1,
    views: 980000,
    chapters: 64,
    updateTime: '2026-06-15',
    tags: ['校园', '搞笑', '日常', '友情'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '花间词：宫廷秘史',
    author: '李素英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20illustration%20of%20a%20beautiful%20woman%20in%20traditional%20Korean%20hanbok%20in%20ancient%20palace%20garden%2C%20cherry%20blossoms%2C%20elegant%20and%20refined%20atmosphere%2C%20soft%20pastel%20pink%20and%20green%20tones%2C%20webtoon%20cover%20style%2C%20romantic%20historical%20digital%20art&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    description: '朝鲜王朝时期，一位身份卑微的宫女凭借超凡的智慧和诗词才华，在波谲云诡的后宫中步步为营。当她与年轻英俊的王相遇，一段禁忌之恋在宫墙深处悄然绽放，却也引来了杀身之祸。',
    status: '连载中',
    rating: 9.8,
    views: 1780000,
    chapters: 110,
    updateTime: '2026-08-04',
    tags: ['古风', '宫廷', '恋爱', '权谋'],
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    title: '双生星',
    author: '金宇彬',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20illustration%20of%20two%20handsome%20young%20men%20facing%20each%20other%20with%20intense%20gaze%2C%20starry%20night%20sky%20background%2C%20soft%20blue%20and%20purple%20tones%2C%20romantic%20atmosphere%2C%20webtoon%20cover%20style%2C%20delicate%20digital%20art%2C%20emotional%20mood&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '耽美',
    categorySlug: 'bl',
    description: '两位天才练习生在残酷的偶像选拔中相识相知，从竞争对手到彼此的依靠。在追逐梦想的路上，他们发现对方就是自己生命中那颗最亮的双生星，一段温暖治愈的青春故事。',
    status: '连载中',
    rating: 9.2,
    views: 1560000,
    chapters: 48,
    updateTime: '2026-08-02',
    tags: ['偶像', '青春', '治愈', '梦想'],
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: '甜蜜的陷阱',
    author: '张娜拉',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20thriller%20illustration%20of%20a%20mysterious%20woman%20with%20half%20angelic%20half%20demonic%20face%2C%20rose%20petals%20floating%2C%20dark%20crimson%20and%20white%20contrast%2C%20webtoon%20cover%20style%2C%20seductive%20yet%20dangerous%20mood%2C%20digital%20art%2C%20dramatic%20lighting&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    description: '心理医生林恩熙接手了一个特殊病患——连环诈骗案的唯一幸存者。随着治疗的深入，她发现这个看似柔弱的女孩背后隐藏着一个精心设计的甜蜜陷阱，而她自己也不知不觉地成为了猎物。',
    status: '连载中',
    rating: 9.3,
    views: 1120000,
    chapters: 42,
    updateTime: '2026-08-01',
    tags: ['心理', '悬疑', '都市', '反转'],
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '花漾年华',
    author: '郑美妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20GL%20romance%20illustration%20of%20two%20beautiful%20women%20in%20flower%20garden%2C%20holding%20hands%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20mint%20green%20tones%2C%20webtoon%20cover%20style%2C%20gentle%20and%20warm%20mood%2C%20delicate%20digital%20art%2C%20floral%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '百合',
    categorySlug: 'gl',
    description: '花艺师尹素熙和咖啡店老板姜荷娜在一条安静的街道上比邻而居，从互不相识到彼此依赖。两个温柔的灵魂在花香和咖啡香中慢慢靠近，一段细腻动人的感情悄然绽放。',
    status: '已完结',
    rating: 9.4,
    views: 870000,
    chapters: 38,
    updateTime: '2026-07-10',
    tags: ['日常', '治愈', '美食', '花卉'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '无限重生：末日战神',
    author: '赵太贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20illustration%20of%20a%20battle%20hardened%20warrior%20in%20ruined%20cityscape%2C%20holding%20weapon%2C%20dark%20dramatic%20sky%2C%20orange%20and%20black%20tones%2C%20webtoon%20cover%20style%2C%20intense%20action%20mood%2C%20digital%20art%2C%20destruction%20aesthetic&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '末日降临，丧尸横行。特种兵韩在宇在末日中战斗十年后惨死，却意外重生回到末日爆发前一天。带着十年的战斗记忆，这一次他要改写命运，成为末日中的最强战神！',
    status: '连载中',
    rating: 9.6,
    views: 2340000,
    chapters: 68,
    updateTime: '2026-08-05',
    tags: ['重生', '末日', '异能', '战斗'],
    isHot: true,
    isNew: false,
  },
  {
    id: 12,
    title: '恋爱补习班',
    author: '安智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20comedy%20illustration%20of%20a%20nerdy%20girl%20and%20popular%20boy%20sitting%20together%20in%20library%2C%20books%20and%20hearts%20floating%2C%20bright%20and%20cheerful%20school%20setting%2C%20warm%20yellow%20and%20aqua%20tones%2C%20webtoon%20cover%20style%2C%20cute%20digital%20art&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '学霸女主为了赚零花钱开了一个恋爱补习班，没想到第一个报名的就是她暗恋已久的校草。一对一教学过程中，到底是谁在教谁恋爱呢？甜蜜又青涩的校园恋情即将上演！',
    status: '已完结',
    rating: 9.0,
    views: 760000,
    chapters: 52,
    updateTime: '2026-05-20',
    tags: ['校园', '甜宠', '搞笑', '学霸'],
    isHot: false,
    isNew: false,
  },
];

export const hotComics = comics.filter(c => c.isHot).sort((a, b) => b.views - a.views);

export const newComics = comics.filter(c => c.isNew).sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());

export const rankingComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

export const latestUpdates = [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, 8);

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter(c => c.categorySlug === slug);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find(c => c.id === id);
}